export class TaskTypeConversionDTO {
  taskId: number;

  targetTaskType: number;

  //only used for the target type Monitoring (an annual plan task)
  recurringPattern?: string;

  constructor() {
    this.taskId = 0;
    this.targetTaskType = 0;
  }
}
